import { render, staticRenderFns } from "./goodsMaintenance.vue?vue&type=template&id=04ebe120&scoped=true&"
import script from "./goodsMaintenance.vue?vue&type=script&lang=js&"
export * from "./goodsMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./goodsMaintenance.vue?vue&type=style&index=0&id=04ebe120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebe120",
  null
  
)

component.options.__file = "goodsMaintenance.vue"
export default component.exports